// extracted by mini-css-extract-plugin
export default {"main-container":"ListingHeaderLayout_main-container__ItmYh","main-container-mobile":"ListingHeaderLayout_main-container-mobile__uboXG"};